module.exports = __webpack_public_path__ + "img/headDefault.62eaba38.png";